export default [
  {
    path: 'gestao/sms',
    name: 'sms',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'SMS',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Sms' }
      ]
    }
  },
]